package com.essntl.core.whatsapp.domain.models

import kotlinx.serialization.Serializable

@Serializable
data class WhapiTextMessageTemplate(
    val to: String,
    val body: String
)
